import { NotificationManager } from 'react-notifications';
import axios from 'axios';
import { IQueryParams } from 'src/types';

import { IProviderListData } from '../providersPayment/types';

export const fetchProvidersMerchantsRequest = async ({ page, size, ...data }: IQueryParams): Promise<IProviderListData | null> => {
  try {
    const res = await axios.post('api/v1/providers/payout/merchant-accounts', data, { params: { page, size } });
    return res.data;
  } catch (error) {
    NotificationManager.error("Can't fetch providers");
    return null;
  }
};
